import RequestUtils from "utils/RequestUtils";
import CreateCastReportReq from "types/req/castReport/CreateCastReportReq";

export default class ReportApi {
  static async create(companyId: number, req: CreateCastReportReq) {
    return await RequestUtils.postVoid(`/report/create/${companyId}`, req);
  }
}
